module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "impact-donate-wrapper"
    }
  }, [(!_vm.isAchieved) ? _c('Donate', {
    attrs: {
      "productId": _vm.productId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAchieved) ? _c('div', {
    staticClass: "wwf-form donation-form donate-impact-wrapper"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.product.meta.projectTitle) + " has reached its funding goal!")]), _vm._v(" "), _c('p', {
    staticClass: "tagline"
  }, [_vm._v("Check out this other similar project that you may be interested in!")]), _vm._v(" "), _c('a', {
    staticClass: "project-button",
    attrs: {
      "href": _vm.redirectUrl
    }
  }, [_vm._v("Similar Project")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce57914","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/impact-project/ImpactDonateWrapper.vue
// module id = 663
// module chunks = 0